"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundFreightErrorMessage = exports.InboundFreightErrorCode = void 0;
var InboundFreightErrorCode;
(function (InboundFreightErrorCode) {
    InboundFreightErrorCode["PALLETS_TOO_MANY"] = "PALLETS_TOO_MANY";
    InboundFreightErrorCode["PALLETS_WEIGHT_BELOW_MINIMUM"] = "PALLETS_WEIGHT_BELOW_MINIMUM";
    InboundFreightErrorCode["PICKUP_DATE_OFF_DAY"] = "PICKUP_DATE_OFF_DAY";
    InboundFreightErrorCode["PICKUP_DATE_TOO_FAR_AWAY"] = "PICKUP_DATE_TOO_FAR_AWAY";
    InboundFreightErrorCode["PICKUP_DATE_SAME_DAY"] = "PICKUP_DATE_SAME_DAY";
    InboundFreightErrorCode["PICKUP_ASN_MISSING"] = "PICKUP_ASN_MISSING";
    InboundFreightErrorCode["PICKUP_WEIGHT_CLASS_NON_EXISTANT"] = "PICKUP_WEIGHT_CLASS_NON_EXISTANT";
    InboundFreightErrorCode["PICKUP_NON_SUPPORTED_REGION"] = "PICKUP_NON_SUPPORTED_REGION";
})(InboundFreightErrorCode = exports.InboundFreightErrorCode || (exports.InboundFreightErrorCode = {}));
exports.InboundFreightErrorMessage = {
    PALLETS_TOO_MANY: "too many pallets",
    PALLETS_WEIGHT_BELOW_MINIMUM: "total weight of all pallets below the minimum required weight",
    PICKUP_DATE_OFF_DAY: "cant schedule pickups on weekends or holidays",
    PICKUP_DATE_TOO_FAR_AWAY: "pickup date is over 2 weeks away",
    PICKUP_DATE_SAME_DAY: "pickup date is same day or in past",
    PICKUP_ASN_MISSING: "couldnt find an asn for this pickups shipment",
    PICKUP_WEIGHT_CLASS_NON_EXISTANT: "weight class must be one of ALL_FREIGHT_CLASSES_WITH_NMFC",
    PICKUP_NON_SUPPORTED_REGION: "we do not provide trucks to provided region",
};
//# sourceMappingURL=FreightError.js.map